import log from 'loglevel';

import { scrollTo } from '../common/utils';
import accordions from '../components/accordions';
import pageContent from '../components/page-content';
import sidebarDrawer from '../components/sidebar/drawer';

const processUrlHash = async () => {
    const { hash } = location;

    if (hash.length === 0) {
        return;
    }

    const $target = $(hash);

    if ($target.length === 0) {
        log.error(`Could not find element "${hash}".`);
        return;
    }

    if (accordions.isItem($target)) {
        await accordions.openItem($target);

        const $accordion = accordions.els.$accordionForItem($target);
        if (accordions.usesScrollBehavior($accordion)) {
            return;
        }
    }

    await scrollTo($target, { scroller: pageContent.els.$content() });
};

const handleAnchorClick = async ($anchor) => {

    const hash = $anchor.attr('href');

    if (hash.length === 0) {
        return;
    }

    const $target = $(hash);

    if ($target.length === 0) {
        log.error(`Could not find element "${hash}".`);
        return;
    }

    if (sidebarDrawer.isInDrawerMode()) {
        await sidebarDrawer.close();
    }

    if (accordions.isItem($target)) {
        await accordions.openItem($target);
    }

    history.replaceState(
        undefined,
        undefined,
        hash
    );

    await scrollTo(
        $target,
        { scroller: pageContent.els.$content() }
    );
};

const initialize = () => {
    processUrlHash();

    $(window).on('hashchange', () => {
        processUrlHash();
    });

    $('a[href^="#"]').on('click', (event) => {
        event.preventDefault();
        handleAnchorClick($(event.currentTarget));
    });
};

export default {
    initialize,
};

